import gql from 'graphql-tag';

export const dokkioTagFacetValueFragment = gql`
  fragment dokkioTagFacetValueFragment on DokkioTagFacetValue {
    dokkioClass
    count
    dokkioTagID
    dokkioTag {
      dokkioClass
      id
      dokkioLabelID
      name
      namePlural
      icon
    }
  }
`;
export default dokkioTagFacetValueFragment;
